import api from "@/plugins/api/EntryPoint";
export default {
  async sendIndications(indications, callBackFn) {
    return api.post("indication/input-new", indications, callBackFn);
  },
};
